export default "__VITE_ASSET__6dcd7dc3__"